<template>
	<div class="modal fade" ref="modal">
		<smartModal
			ref="sModal"
			:chForm="fBase"
			@cancelar="close"
			@salvar="save"
			@imprimir="printDocument"
		/>
	</div>
</template>
<script>
	import smartModal from '../../create-form/components/mdFormLoad.vue';
	import clone from 'js/clone';
	import WBS from 'js/http';
	import toastr from 'toastr';

	export default {
		name: 'ModelsTablesModal',
		props: ['fBase', 'tid'],
		components: { smartModal },
		data() {
			return {
				lineData: null,
			};
		},
		computed: {
			chForm() {
				return clone(this.fBase);
			},
		},
		methods: {
			printDocument(data) {
				this.$refs.sModal.toggleStatusBtn('imprimir');

				this.saveBase(data).then((resp) => {
					const sData = {
						form: data,
						templateId: this.chForm.settings.printInfo,
						inputs: this.chForm.inputs,
					};
					WBS.send(
						'protected-custom-smtbPrintDocument',
						sData,
						(resp) => {
							if (resp.status == 'success') {
								window.open(resp.data);
								this.$refs.sModal.toggleStatusBtn('imprimir');
							} else {
								toastr.error(msg);
							}
						}
					);
				});
			},
			prepare(data) {
				let prepare = [];
				for (let item in data.cods) {
					prepare.push({
						cod_form: this.fBase.cod,
						id: item,
						value: data[item],
					});
				}
				return prepare;
			},
			open(data = null) {
				this.lineData = null;
				this.$refs.sModal.clear();
				if (data != null) {
					this.lineData = clone(data);
					this.$refs.sModal.load(this.prepare(data));
				}
				$(this.$refs.modal).modal('show');
			},
			close() {
				$(this.$refs.modal).modal('hide');
			},

			saveBase(data) {
				return new Promise((response, reject) => {
					let sData = clone(data);
					if (this.lineData != null) {
						sData.forEach((item) => {
							item.rid = this.lineData.rid;
							if (this.lineData.cods[item.id] != undefined)
								item.cod = this.lineData.cods[item.id];
						});
					}

					WBS.send(
						'private-save-smartTables:items',
						{ tid: this.tid, objeto: sData },
						(resp) => {
							if (resp.status == 'success') {
								response(resp);
							} else {
								toastr.error('Erro ao salvar documento!');
								reject();
							}
						}
					);
				});
			},

			save(data) {
				this.$refs.sModal.toggleStatusBtn('salvar');
				this.saveBase(data).then((resp) => {
					toastr.success('Dados salvos com sucesso!');
					this.$refs.sModal.toggleStatusBtn('salvar');
					$(this.$refs.modal).modal('hide');
					this.$emit('updateTable');
				});
			},
		},
	};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/models/tables/components/modal.vue